import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import JiraAttachments from './JiraAttachments';
import { removeBoldTags } from '../../Helpers/SearchHelpers';

export default class JiraDetails extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col lg={{ span: 3 }}>
                        <div className='D365-content-container case-details'>
                            <p>
                                <strong>Jira Key : </strong>
                                <a
                                    href={`${removeBoldTags(this.props.JiraDetails.uURL)}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    {this.props.JiraDetails.uJiraKey}
                                </a>
                                <span> (requires Jira license)</span>
                            </p>
                            <p>
                                <strong>Status : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uStatus)}`}
                            </p>
                            <p>
                                <strong>Priority : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uPriority)}`}
                            </p>
                            <p>
                                <strong>Severity : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uSeverity)}`}
                            </p>
                            <p>
                                <strong>Assignee : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uAssignee)}`}
                            </p>
                            <p>
                                <strong>Team : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uTeam)}`}
                            </p>
                            <p>
                                <strong>Bug Type : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uBugType)}`}
                            </p>
                            <p>
                                <strong>Issue Type : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uIssueType)}`}
                            </p>
                            <p>
                                <strong>Fix Versions : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uFixVersions)}`}
                            </p>
                            <p>
                                <strong>Project Name : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uProjectName)}`}
                            </p>
                            <p>
                                <strong>Product Team : </strong>
                                {`${removeBoldTags(this.props.JiraDetails.uProductTeam)}`}
                            </p>
                            <p>
                                <strong>Created Date : </strong>
                                {moment(this.props.JiraDetails.uCreatedDate).format(
                                    'YYYY-MM-DD'
                                )}
                            </p>
                            <p>
                                <strong>Changed Date : </strong>
                                {moment(this.props.JiraDetails.Modified).format('YYYY-MM-DD')}
                            </p>
                        </div>
                    </Col>
                    <Col lg={{ span: 9 }}>
                        <div className='D365-content-container'>
                            <h6 className='m-0'>
                                {removeBoldTags(this.props.JiraDetails.ResultTitle)}
                            </h6>
                            <div className='mb-2 d365-subtitles'></div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div className='quickview-info'>
                        <p>
                            <strong>Description :</strong>
                            <br /> {removeBoldTags(this.props.JiraDetails.uDescription)}
                        </p>
                        <p>
                            <strong>Steps to Reproduce :</strong>
                            <br /> {removeBoldTags(this.props.JiraDetails.uStepsToReproduce)}
                        </p>
                        <p>
                            <strong>Current Behavior :</strong>
                            <br /> {removeBoldTags(this.props.JiraDetails.uCurrentBehavior)}
                        </p>
                        <p>
                            <strong>Expected behavior :</strong>
                            <br /> {removeBoldTags(this.props.JiraDetails.uExpectedBehavior)}
                        </p>
                        <p>
                            <strong>Acceptance Criteria :</strong>
                            <br /> {removeBoldTags(this.props.JiraDetails.uAcceptanceCriteria)}
                        </p>
                        {this.props.JiraDetails.uAttachments.length === 0 && (
                            <p>
                                <strong>Attachments (0):</strong>
                                <br />
                            </p>
                        )}
                        {this.props.JiraDetails.uAttachments.length > 0 && (
                            <JiraAttachments
                                jiraAttachments={this.props.JiraDetails.uAttachments}
                            />
                        )}
                    </div>
                </Row>
            </div>
        );
    }
}